module.exports = __webpack_public_path__ + "img/card2.11f00600.png";